import Vue from 'vue';

export default Vue.component('inputfield', {
    template:`
    <input class="form-control" :type="type" :value="value" @input="$emit('input', $event.target.value)" :disabled="disabled" />
    `,
    props:{
        type: { 
            type: String, 
            default: 'text' 
        },
        value: { 
            default: '' 
        },
        disabled: { 
            type: Boolean, 
            default: false 
        }
    }
});